import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "float-right" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  filter: "message",
  sort: "message"
}
const _hoisted_5 = {
  filter: "author",
  sort: "author"
}
const _hoisted_6 = {
  filter: "dayNumber",
  sort: "dayNumber"
}
const _hoisted_7 = {
  filter: "monthNumber",
  sort: "monthNumber"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { colspan: "99" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-danger" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addMessage && _ctx.addMessage(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Aggiungi messaggio",
          text: "Aggiungi messaggio"
        })
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Verrà mostrato il messaggio che corrisponde al GIORNO e al MESE.",
        text: "Verrà mostrato il messaggio che corrisponde al GIORNO e al MESE."
      }),
      _hoisted_2,
      _createVNode(_component_localized_text, {
        localizedKey: "Se non c'è una corrispondenza anche con il mese, verrà mostrato il messaggio che corrisponde al giorno.",
        text: "Se non c'è una corrispondenza anche con il mese, verrà mostrato il messaggio che corrisponde al giorno."
      }),
      _hoisted_3,
      _createVNode(_component_localized_text, {
        localizedKey: "Se non c'è neanche corrispondenza neanche con il giorno, non verrà mostrato il messaggio.",
        text: "Se non c'è neanche corrispondenza neanche con il giorno, non verrà mostrato il messaggio."
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.messages
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Messaggio",
                text: "Messaggio"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Autore",
                text: "Autore"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Giorno numero",
                text: "Giorno numero"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Mese numero",
                text: "Mese numero"
              })
            ]),
            _hoisted_8
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                _createElementVNode("td", _hoisted_10, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": ($event: any) => ((item.message) = $event),
                  class: "form-control",
                  rows: "3"
                }, null, 8, _hoisted_11), [
                  [_vModelText, item.message]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((item.author) = $event)
                }, null, 8, _hoisted_12), [
                  [_vModelText, item.author]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((item.dayNumber) = $event)
                }, null, 8, _hoisted_13), [
                  [_vModelText, item.dayNumber]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((item.monthNumber) = $event)
                }, null, 8, _hoisted_14), [
                  [_vModelText, item.monthNumber]
                ])
              ]),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary ml-2",
                  onClick: ($event: any) => (_ctx.saveItem(item))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Salva",
                    text: "Salva"
                  })
                ], 8, _hoisted_16),
                (item.identifier)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(["btn btn-sm ml-2", { 'btn-warning': !item.disabled, 'btn-success': item.disabled }]),
                      onClick: ($event: any) => (_ctx.disableItem(item))
                    }, [
                      (!item.disabled)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_18,
                            _hoisted_19,
                            _createVNode(_component_localized_text, {
                              localizedKey: "Disabilita",
                              text: "Disabilita"
                            })
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_20,
                            _hoisted_21,
                            _createVNode(_component_localized_text, {
                              localizedKey: "Abilita",
                              text: "Abilita"
                            })
                          ], 64))
                    ], 10, _hoisted_17))
                  : _createCommentVNode("", true),
                (item.identifier)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-sm btn-danger ml-2",
                      onClick: ($event: any) => (_ctx.removeItem(item))
                    }, _hoisted_24, 8, _hoisted_22))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}